(function(w, d, __tnt){
    var content_url,
        nav_url,
        is_fetching = false,
        prev_y = 0,
        prev_ratio = 0,
        is_finished = false,
        fetchers_finished = 0,
        assets_tracked = [],
        assets_inserted = 0,
        block_id,
        content_template,
        nav_template,
        ad_template,
        container,
        nav_container,
        ad_observer,
        content_observer,
        content_fetcher,
        nav_fetcher,
        asset_el;

    var showSpinner = function() {
        d.querySelector('#btn-infinite-load .tnt-spinner').style.display = '';
    };

    var hideSpinner = function() {
        d.querySelector('#btn-infinite-load .tnt-spinner').style.display = 'none';
    };

    var contentIntersection = function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var asset_id = entry.target.dataset.uuid;
                if (nav_container) {
                    var nav_items = nav_container.querySelectorAll('.list-group-item');
                    for (var i = 0; i < nav_items.length; i++) {
                        nav_items[i].classList.remove('active');
                        if (nav_items[i].dataset.uuid == asset_id) {
                            nav_items[i].classList.add('active');

                            if (nav_container.offsetParent !== null) {
                                scrollParentToChild(nav_container, nav_items[i]);
                            }
                        }
                    }
                }

                d.querySelectorAll('.main-content .article-infinity-story').forEach(function(article) {
                    if (article.dataset.uuid == asset_id) {
                        // history/url
                        w.history.replaceState(null, null, __tnt.scrubUrl(article.dataset.url + location.search));

                        // title
                        var sTitle = '';
                        if (location.href.indexOf('tncms/admin') != -1) {
                            sTitle += 'SITE PREVIEW: ';
                        }
                        sTitle += article.dataset.title;
                        sTitle += ' | ' + container.dataset.sitename;

                        d.title = sTitle;

                        // tracking
                        trackAsset(asset_id, function(){
                            __tnt.trackEvent({'url':article.dataset.url, 'title':article.dataset.title});
                        });

                        var assetChangeEvent = new CustomEvent('infinity-story-asset-change', {
                            detail: {
                                assetElement: entry.target
                            }
                        });
                        document.dispatchEvent(assetChangeEvent);
                    }
                });
            }
        });
    };

    var adIntersection = function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var infinity_ad = entry.target;
                var new_iframe = createInfinityAd(infinity_ad.dataset.adId);

                infinity_ad.classList.remove('empty');
                if (infinity_ad.childElementCount <= 0) {
                    infinity_ad.append(new_iframe);
                    ad_observer.unobserve(infinity_ad);
                }
            }
        });
    };

    var registerEvents = function() {
        // click event listener for items in the infinite nav container
        if (nav_container) {
            nav_container.addEventListener('click', function(e){
                if (e.target.matches('a')) {
                    var el = d.querySelector('.main-content .article-infinity-story[data-uuid="'+ e.target.dataset.uuid +'"]');
                    if (el) el.scrollIntoView();
                    // Offset scroll if site is using fixed nav
                    var navbar = d.getElementById('site-navbar-container');
                    if (navbar && (navbar.classList.contains('affix-top') || navbar.classList.contains('affix'))) {
                        w.scrollBy(0, -60);
                    }
                }
            });
        }

        d.addEventListener('infinity-story-fetch', function(e) {
            if (e.detail) {
                if (e.detail.type === 'nav') {
                    e.detail.assets.forEach(function(asset, index) {
                        var df = d.createDocumentFragment();
                        var html = fillNav(asset);
                        df.appendChild(html);
                        nav_container.querySelector('.list-group').appendChild(df);
                    });
                } else if (e.detail.type === 'content') {
                    e.detail.assets.forEach(function(asset, index) {
                        var df = d.createDocumentFragment();
                        var html = fillContent(asset);
                        df.appendChild(html);
                        container.appendChild(df);
                        var addedEl = container.lastElementChild;
                        if (content_observer) {
                            content_observer.observe(addedEl);
                        }

                        assets_inserted += 1;
                        var insert_event = new CustomEvent('infinity-story-asset-insert', {
                            detail: {
                                elementInserted: addedEl,
                                assetCount: assets_inserted
                            }
                        });
                        d.dispatchEvent(insert_event);

                        executeScriptElements(addedEl);

                        // Advanced automatic ads
                        if (container.dataset.instoryAds === 'true') {
                            __tnt.ads.initAdInjection(addedEl);
                            addedEl.querySelectorAll('.dfp-smart-ad').forEach(function(el) {
                                __tnt.ads.lazyloadObserver.observe(el);
                            });
                        }

                        // Insert new ad div and observe it
                        if (ad_template) {
                            var fragment = templateContent(ad_template).cloneNode(true);
                            container.appendChild(fragment);

                            if (ad_observer) {
                                ad_observer.observe(container.lastElementChild);
                            }
                        }
                    });
                }
            }
        });

        d.addEventListener('infinity-story-fetcher-finished', function(e) {
            fetchers_finished += 1;
            if (fetchers_finished == 2) {
                d.getElementById('btn-infinite-load').style.display = 'none';
            }
        });

        d.getElementById('btn-infinite-load').addEventListener('click', function(){
            infinityStory.getStories();
            if (window.dataLayer) {
                dataLayer.push({
                    'event': 'tncms.event.trigger',
                    'tncms': {
                        'event': {
                            'trigger': {
                                'category': 'infinity-scroll',
                                'action': 'user interaction',
                                'label': 'clicked load more button'
                            }
                        }
                    }
                });
            }
        });
    };

    var trackAsset = function(id, callback) {
        if (assets_tracked.indexOf(id) < 0) {
            assets_tracked.push(id);
            if (typeof callback == 'function') {
                callback();
            }
        }
    };

    var scrollParentToChild = function(parent, child) {
        var parentRect = parent.getBoundingClientRect();
        var parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
        };
        var childRect = child.getBoundingClientRect();
        parent.scrollTop = (childRect.top + (childRect.height/2) + parent.scrollTop) - parentRect.top - (parentViewableArea.height/2);
    };

    var templateContent = function(template) {
        if ('content' in d.createElement('template')) {
            return template.content;
        } else {
            var fragment = d.createDocumentFragment();
            var children = template.childNodes;
            for (i = 0; i < children.length; i++) {
                fragment.appendChild(children[i].cloneNode(true));
            }
            return fragment;
        }
    };

    var executeScriptElements = function(containerEl) {
        var scriptEls = containerEl.querySelectorAll('script');
        Array.from(scriptEls).forEach(function(scriptEl) {
            var clonedEl = document.createElement('script');
            Array.from(scriptEl.attributes).forEach(function(attrib) {
                clonedEl.setAttribute(attrib.name, attrib.value);
            });
            clonedEl.text = scriptEl.text;
            scriptEl.parentNode.replaceChild(clonedEl, scriptEl);
        });
    };

    var fillContent = function(asset) {
        var template = document.createElement('template');
        template.innerHTML = asset.content.trim();
        var clone = template.content.cloneNode(true);
        var links = clone.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
            links[i].href = __tnt.scrubUrl(links[i].href);
        }

        return d.importNode(clone, true);
    };

    var fillNav = function(asset) {
        var clone = templateContent(nav_template).cloneNode(true);
        var list_item = clone.querySelector('.original');
        list_item.dataset.uuid = asset.id;
        list_item.textContent = asset.title;

        return d.importNode(clone, true);
    };

    var createInfinityAd = function(id) {
        var iframe = d.createElement('iframe');
        iframe.scrolling = 'no';
        iframe.src = __tnt.scrubUrl('/tncms/block/' + id + '/?disableTNStatsTracker=1');
        return iframe;
    }

    var infinityStory = {
        init: function() {
            container = d.getElementById('infinite-container');
            nav_container = d.getElementById('infinite-nav-container');
            var order = container.dataset.order;
            var origin_id = container.dataset.originId;

            block_id = (container.dataset.blockId) ? container.dataset.blockId : null;

            content_url = container.dataset.contentUrl;
            nav_url = container.dataset.navUrl;

            nav_template = d.getElementById('infinity-nav-tpl');
            ad_template = (d.getElementById('infinity-ad-tpl')) ? d.getElementById('infinity-ad-tpl') : null;

            content_observer = new IntersectionObserver(contentIntersection, {root:null, rootMargin:'-49% 0px -49% 0px', threshold:0});
            if (ad_template) {
                ad_observer = new IntersectionObserver(adIntersection, {root:null, rootMargin:'100px', threshold:0});
                ad_observer.observe(d.querySelector('.infinity-ad'));
            }

            asset_el = d.querySelector('article.asset');

            content_observer.observe(asset_el);

            content_fetcher = new __tnt.infinityStoryFetcher({
                order: order,
                origin_id: origin_id,
                url: content_url,
                type: 'content'
            });
            if (nav_container) {
                nav_fetcher = new __tnt.infinityStoryFetcher({
                    order: order,
                    origin_id: origin_id,
                    url: nav_url,
                    type: 'nav'
                });
            }

            registerEvents();

            // Init event
            var initEvent = new CustomEvent('infinity-story-asset-init', {
                detail: {
                    assetCount: assets_inserted
                }
            });
            document.dispatchEvent(initEvent);
        },
        getStories: function() {
            showSpinner();
            setTimeout(function(){
                if (is_fetching === false) {
                    is_fetching = true;
                    if (nav_fetcher) {
                        nav_fetcher.fetch();
                    }
                    content_fetcher.fetch(function(){
                        is_fetching = false;
                        hideSpinner();
                    });
                }
            }, 250);
        }
    };

    d.addEventListener('DOMContentLoaded', function() {
        infinityStory.init();
        infinityStory.getStories();
    });
})(window, document, __tnt);